module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.2e9b3d16.ttf";